<template>
  <v-app>
    <RouterView />
    <CqsTimeoutWarning />
  </v-app>
</template>

<script lang="ts">
import { RouterView } from 'vue-router'
import CqsTimeoutWarning from '@/components/shared/CqsTimeoutWarning.vue'
import { useAuthenticationStore } from '@/stores/authentication'

export default {
  components: {
    CqsTimeoutWarning
  },
  created() {
    // Clear stale persisted sessions on startup to prevent the timeout
    // component immediately firing logout on anonymous routes (e.g. password-change)
    const store = useAuthenticationStore()
    if (store.isAuthenticated && store.getTokenExpirySeconds() <= 0) {
      store.user = null
      store.tokens = null
      store.directives = []
      store.tokenValid = false
    }
  }
}
</script>

